import Blob from 'blob';
import { getWindow } from './general';

export const parseBlob = (blobText: string, contentType: string): Blob => {
  return new Blob([blobText], { type: contentType });
};

// Open file in new tab.
export const openFile = (blob: Blob, fileName: string): void => {
  /**  // IE - can probably be depercated since IE is not supported anymore
   *  
   * if (window.navigator.msSaveBlob) {
   
    window.navigator.msSaveOrOpenBlob(blob, fileName);
  } else {
   */

  const aElement = document.createElement('a');
  document.body.appendChild(aElement);
  aElement.setAttribute('style', 'display: none');
  const url = (window.URL || window.webkitURL).createObjectURL(blob);
  aElement.href = url;
  aElement.download = fileName;
  aElement.click();

  setTimeout(() => {
    aElement.remove();
  }, 100);
};

// Save file to downloads folder.
export const saveFile = (blob: Blob, fileName: string): void => {
  /* if (window.navigator.msSaveBlob) {
    // IE - can probably be depercated since IE is not supported anymore
    window.navigator.msSaveOrOpenBlob(blob, fileName);
  } else { */
  const aElement = document.createElement('a');
  document.body.appendChild(aElement);
  aElement.setAttribute('style', 'display: none');
  const url = (window.URL || window.webkitURL).createObjectURL(blob);
  aElement.href = url;
  aElement.download = fileName;
  aElement.click();
  setTimeout(() => {
    if (getWindow()) window.URL.revokeObjectURL(url);
    aElement.remove();
  }, 100);
};

/**
 * Clear Recently Viewed data from sessionStorage so new user will not see old user viewing history
 */
export const clearSessionStorageRVData = () => {
  sessionStorage.removeItem('rvData');
  sessionStorage.removeItem('RVDateStamp');
};

export const redirectToB2BHomePage = () => {
  getWindow()?.location.assign('https://www.homedepot.com'); // `https://www.homedepot.com${B2B_HOMEPAGE_PATH}`
};

export const redirectToSignIn = (): void => {
  getWindow()?.location.replace(
    `/auth/view/signin?redirect=${window.location.pathname}${window?.location?.search}`,
  );
};

export const redirectToSignInWithCustomRedirect = (redirectUrl: string) =>
  getWindow()?.location.replace(`/auth/view/signin?redirect=${redirectUrl}`);

export const redirectGuestOrderTracking = (): void => {
  getWindow()?.location.replace('/myaccount/guest-order-tracking');
};

export const redirecToErrorPage = () => {
  getWindow()?.location.replace(`/error`);
};
